import { Link } from '@tanstack/react-router';
import { useTranslation } from 'react-i18next';
import { useShutdownStatus } from './api';

export const ShutdownBanner = () => {
  const { t, i18n } = useTranslation('common');
  const { data } = useShutdownStatus();

  if (!data?.bannerEnabled) {
    return null;
  }

  const isArabic = i18n.resolvedLanguage === 'ar';

  return (
    <aside
      className="border-b border-amber-300 bg-amber-50 px-4 py-3 text-amber-950 dark:border-amber-700 dark:bg-amber-950 dark:text-amber-50"
      dir={isArabic ? 'rtl' : 'ltr'}
      role="status"
    >
      <div className="mx-auto flex max-w-6xl flex-wrap items-center justify-center gap-x-2 gap-y-1 text-sm">
        <span>{t('shutdown.banner.message')}</span>
        <Link to="/closure" className="font-semibold underline underline-offset-4">
          {t('shutdown.banner.link')}
        </Link>
      </div>
    </aside>
  );
};
